import omit from "lodash/omit";
import Router, { NextRouter } from "next/router";

/**
 * The purpose of using the capital R Router is because in the below functions is because
 * this router object is mutated and is always up-to-date in terms of reading information.
 *
 * The useRouter().query relies on  a re-render and can get lost in function closures so
 * I found that params were being removed instead of being added to. The above ensures all
 * current query params are kept intact.
 */

/**
 * Helper function to remove one or many query parameters from the URL,
 * without adding to browser history or causing a re-render.
 */
export function removeQueryParams(router: NextRouter, params: string[]) {
  void router.replace(
    {
      pathname: router.pathname,
      query: omit(Router.query, params),
    },
    undefined,
    { shallow: true }
  );
}

/**
 * Helper function to add one or many query parameters from the URL,
 * without adding to browser history.
 */
export const addQueryParams = (
  router: NextRouter,
  params: Record<string, string>
) => {
  const noChange = Object.entries(params).every(([key, value]) => {
    return Router.query[key] === value;
  });

  // Prevent needless re-renders
  if (noChange) return;

  void router.replace(
    {
      pathname: router.pathname,
      query: {
        ...Router.query,
        ...params,
      },
    },
    undefined,
    { shallow: true }
  );
};
